import React, { useEffect, useState } from "react";
import "./Categories.css";
import { useNavigate } from "react-router-dom";
import { getWithoutTokenAPI } from "../../util/Api";
import { FaArrowRightLong } from "react-icons/fa6";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

// Fallback local images (keep these as they are)
import freshFruit from "../../assets/Images/Categories/image1.png";
import freshVegetables from "../../assets/Images/Categories/image2.png";
import meatFish from "../../assets/Images/Categories/image3.png";
import snacks from "../../assets/Images/Categories/image4.png";
import beverages from "../../assets/Images/Categories/image5.png";
import beautyHealth from "../../assets/Images/Categories/image6.png";
import breadBakery from "../../assets/Images/Categories/image7.png";
import bakingNeeds from "../../assets/Images/Categories/image8.png";
import cooking from "../../assets/Images/Categories/image9.png";
import diabeticFood from "../../assets/Images/Categories/image10.png";
import dishDetergents from "../../assets/Images/Categories/image11.png";
import oil from "../../assets/Images/Categories/image12.png";

const localCategoryImages = {
  "Fresh Fruit": freshFruit,
  "Fresh Vegetables": freshVegetables,
  "Meat & Fish": meatFish,
  "Snacks": snacks,
  "Beverages": beverages,
  "Beauty & Health": beautyHealth,
  "Bread & Bakery": breadBakery,
  "Baking Needs": bakingNeeds,
  "Cooking": cooking,
  "Diabetic Food": diabeticFood,
  "Dish Detergents": dishDetergents,
  "Oil": oil,
};

const Categories = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  // State to track current window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      const result = await getWithoutTokenAPI("/category/find-all?Approval_status=Approval");
      if (result && !result.error && result.data?.categories) {
        const dataWithImages = result.data.categories.map((cat) => ({
          id: cat._id,
          name: cat.category_name,
          image: cat.image || localCategoryImages[cat.category_name] || "",
          seller: cat?.created_by?.name || "Unknown",
        }));
        setCategories(dataWithImages);
      } else {
        console.error("Failed to load categories:", result.error || "Invalid response format");
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    navigate(
      `/shop?category_id=${category.id}&category_name=${encodeURIComponent(category.name)}`,
      {
        state: {
          selectedCategoryId: category.id,
          selectedCategoryName: category.name
        },
      }
    );
  };

  // Custom Next Arrow Component
  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    const isDesktopView = windowWidth > 992; // Adjust breakpoint for desktop as needed

    // If not enough categories to scroll or at the very end
    if (categories.length <= 7 || props.currentSlide >= props.slideCount - props.slidesToShow) {
      return null;
    }

    // Always show next arrow on desktop if not at the end
    // For mobile, this will also be true as long as there's more to scroll
    return (
      <div
        className={`custom-slick-next-arrow ${className}`}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <div className="arrow-card">
          <FiChevronRight size={30} color="#000" />
        </div>
      </div>
    );
  };

  // Custom Previous Arrow Component
  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    const isDesktopView = windowWidth > 992; // Adjust breakpoint for desktop as needed

    // If not enough categories for carousel, or at the very beginning (slide 0)
    if (categories.length <= 7 || props.currentSlide === 0) {
      // On desktop, hide if at slide 0
      // On mobile, also hide if at slide 0 (standard behavior)
      return null;
    }

    // On desktop, show if currentSlide > 0 (i.e., moved from the start)
    // On mobile, show if currentSlide > 0
    return (
      <div
        className={`custom-slick-prev-arrow ${className}`}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <div className="arrow-card">
          <FiChevronLeft size={30} color="#000" />
        </div>
      </div>
    );
  };


const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,  // Show 2 items per row
        slidesToScroll: 2, // Scroll 2 items at a time
        centerMode: false, // Disable center mode for better alignment
        arrows: true,     // Ensure arrows are enabled
        variableWidth: false // Ensure fixed width for items
      }
    }
  ]
};

  return (
    <div className="category-bg-main">
      <div className="container-fluid category-bg">
        {categories.length > 0 && (
          <>
          <div>
            
          </div>
            <h6 className="text-center ff-poppins fs-14 fw-500 fc-green category-title" data-aos="fade-up">CATEGORY</h6>
                          <h2 className="ff-poppins fs-36 fw-600 category-title-2" data-aos="fade-up">Shop by Top Categories</h2>
            <div className="d-flex justify-content-end mb-4"> {/* Changed to justify-content-between */}

              {/* "View All" button at the top right, only if there are more than 7 categories */}
              {categories.length > 7 && (
              <button
  className="btn custom-view-btn ff-poppins fw-600 fs-14"
  onClick={() => navigate("/allcategories")}
  data-aos="fade-left"
  data-aos-delay="300"
>
  View All <FaArrowRightLong className="ms-2" />
</button>

              )}
            </div>
          </>
        )}

        <div className="row mt-4 p-4">
          {/* Conditionally render Slider or a simple grid */}
         
          {categories.length > 7 ? (
            <Slider {...settings}>
              {categories.map((category, index) => (
                <div key={index} className="px-2" data-aos={['fade-up', 'zoom-in', 'fade-right', 'flip-left', 'fade-down'][index % 5]}>
                  <div
                    className="category-box text-center"
                    onClick={() => handleCategoryClick(category)}
                  >
                    <img
                      src={category.image}
                      alt={category.name}
                      className="img-fluid mb-2 category-image"
                    />
                    <p className="ff-poppins fw-500 fs-13 category-box-category-name mb-0">
                      {category.name}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            // Render a simple flex grid if 7 or fewer categories
            <div className="categories-wrapper">
              {categories.map((category, index) => {
                const animations = ['fade-up', 'zoom-in', 'fade-right', 'flip-left', 'fade-down'];
                const animationType = animations[index % animations.length];

                return (
                  <div key={index} className="category-col" data-aos={animationType}>
                    <div
                      className="category-box text-center"
                      onClick={() => handleCategoryClick(category)}
                    >
                      <img
                        src={category.image}
                        alt={category.name}
                        className="img-fluid mb-2 category-image "
                      />
                      <p className="ff-poppins fw-500 fs-13 category-box-category-name mb-0">
                        {category.name}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Categories;
